import * as React from 'react';
import styles from './CategoryHotLink.scss';
import classNames from 'classnames';
import equal from 'fast-deep-equal/react';
import { openCategoryByName } from '~/utils/category';
import { settings } from '~/utils/settings';
import { RootState, useAppSelector } from '~/Store';

interface ICategoryHotLink {
    className?: string;
    wrapperClassName?: string;
    labelClassName?: string;
    link: IHotLink;
}

const stateSelector = (state: RootState) => {
    return {
        currentPage: state.app.currentPage,
        categories: state.app.categories,
    };
};

const CategoryHotLink = ({ className, link, wrapperClassName, labelClassName }: ICategoryHotLink) => {
    const { currentPage } = useAppSelector(stateSelector, equal);

    if (currentPage?.isBundlePage) {
        return null;
    }

    const onClick = () => {
        openCategoryByName(link.categoryName);
    };

    const classesContent = classNames(styles.content, className, {
        [styles.withShiny]: !!link.images.shiny,
    });

    const classesWrapper = classNames(styles.wrapper, styles[settings.realm], wrapperClassName);
    const classesLabel = classNames(styles.label, labelClassName);

    const style = {
        '--hot-link-shiny': `url(${link.images.shiny})`,
        '--hot-link-background': `url(${link.images.background})`,
    } as React.CSSProperties;

    return (
        <div className={classesContent} style={style}>
            <div className={classesWrapper} onClick={onClick}>
                <span className={classesLabel}>{link.title}</span>
            </div>
        </div>
    );
};

export default CategoryHotLink;
